define([
	"dojo/_base/declare",
	"csi/state/rootStore",
	"Apparel/NewProductSamples"
], function(declare,{ routerStore },NewProductSamples) {
    
    return declare(NewProductSamples, {
        /**
         * @override
         * initialize samples form with product
         */
        onCreatePopup: function(view) {
            view.setProduct(routerStore.getBreadcrumbNode("Material"));
            view.setColor(this.getParent());
        }
	});
});